/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../components/shared/Dialog/DialogContainer';  
import { FaHistory } from 'react-icons/fa';
import OrgUserHistory from './OrgUserHistory';
import OrgUserEdit from './OrgUserEdit';

const OrgUsersList = () => {
    const [selectedOrgUsers, setselectedOrgUsers] = useState({});
    const [openEditOrgUsers, setopenEditOrgUsers] = useState(false);
    const [openHistoryOrgUsers, setopenHistoryOrgUsers] = useState(false);
    const orgUsersList = useSelector(state => state.orgUsers.orgUsersList)
    const handleCloseDialog = () => {
        setopenEditOrgUsers(false);
        setopenHistoryOrgUsers(false);
    } 
    return (
        <><TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Organization Name" />
                            <StyledTableCell label="User ID" />

                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {orgUsersList?.Records?.length > 0 && orgUsersList.Records.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.organizationName} />
                                <StyledTableCell label={row.getChkdID} />

                                <StyledTableCell   >
                                    {row.organizationUserDetails.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.organizationUserDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.organizationUserDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                        </Typography> : "N/A"}
                                </StyledTableCell>

                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setselectedOrgUsers(row); setopenEditOrgUsers(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setselectedOrgUsers(row); setopenHistoryOrgUsers(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> 


            <DialogContainer
                open={openEditOrgUsers}
                handleClose={handleCloseDialog}
            >
                <OrgUserEdit
                    selectedOrgUser={selectedOrgUsers}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgUsers}
                handleClose={handleCloseDialog}
            >
                <OrgUserHistory
                    selectedOrgUser={selectedOrgUsers}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

 
export default OrgUsersList;
